var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "div",
        [
          _c(
            "b-btn",
            {
              staticClass: "btn-danger my-1 text-uppercase fs-12",
              attrs: { disabled: _vm.errors },
              on: { click: _vm.showModal },
            },
            [_vm._v("Сформировать итоговый протокол закупочной сессии")]
          ),
          _c("p", { staticClass: "text-danger fs-14" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ]),
          _c(
            "b-modal",
            {
              ref: "cancel-modal",
              attrs: {
                centered: "",
                "hide-header-close": "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": "",
                size: "lg",
                title: "Сформировать итоговый протокол закупочной сессии",
              },
              model: {
                value: _vm.isModalVisible,
                callback: function ($$v) {
                  _vm.isModalVisible = $$v
                },
                expression: "isModalVisible",
              },
            },
            [
              _c("p", { staticClass: "text-danger fw-600 fs-16 my-1" }, [
                _vm._v(
                  "Внимание! Данная операция необратима. Убедитесь в корректности заполненных данных перед формированием итогового протокола!"
                ),
              ]),
              _c("p", { staticClass: "text-danger fw-600 fs-16 my-1" }, [
                _vm._v(
                  'Если Вы производили рейтингование заявок участников, убедитесь в корректности проставленных значений перед нажатием кнопки "СФОРМИРОВАТЬ ПРОТОКОЛ"'
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "w-100 text-right",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer",
                },
                [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase mr-2",
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.cancelModal },
                        },
                        [_vm._v("Отменить")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: { variant: "custom-danger" },
                          on: { click: _vm.store },
                        },
                        [_vm._v("Сформировать протокол")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }